<template>
  <q-dialog v-model="currentVisible" content-class="dialog-create-dashboard" @hide="resetDialog">
    <q-layout
      view="hHh lpR fFf"
      container
      :style="{ height: '600px', minWidth: '800px' }"
      class="shadow-2 rounded-borders"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>{{ $t('Create New Dashboard') }}</q-toolbar-title>
          <q-btn flat v-close-popup round dense icon="close"></q-btn>
        </q-toolbar>
      </q-header>

      <q-page-container class="bg-content">
        <q-page padding>
          <Stepper v-model="step">
            <Step
              :title="$t('Dashboard Settings')"
              :name="1"
              :done="step > 1"
              :header-nav="false"
              hide-back-btn
              @next="handleNext"
              @cancel="currentVisible = false"
            >
              <Form ref="myForm" style="width: 730px">
                <div class="q-gutter-md">
                  <Input
                    name="dashboardName"
                    required
                    :label="$t('Dashboard name')"
                    v-model="dashboardName"
                    :error-msg="$t('Please enter the dashboard name.')"
                    :description="$t('Please enter within 30 characters.')"
                    :placeholder="$t('Dashboard name')"
                  />
                  <ButtonToggle
                    v-model="buttonToggleValue"
                    :options="buttonToggleOptions"
                    size="md"
                  />
                  <!-- <Input
                  name="new_user"
                  required
                  :label="$t('User Permissions')"
                  v-model="dashboardName"
                  placeholder="Add user"
                /> -->
                </div>
              </Form>
            </Step>
            <Step
              :title="$t('Add widget')"
              :name="2"
              :header-nav="false"
              @cancel="currentVisible = false"
              @previous="step = 1"
              @submit="handleSubmit"
              submit=""
            >
              <div
                @click="handleAddWidget('chart')"
                class="cursor-pointer hover-border"
                :class="{ active: isSelected('chart') }"
              >
                <Panel :title="$t('Chart')" class="q-mb-md"></Panel>
              </div>
            </Step>
          </Stepper>
        </q-page>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Panel from '@design-system/components/Panel';
import ButtonToggle from '@design-system/components/ButtonToggle';
import Input from '@design-system/components/Input';
import Stepper from '@design-system/components/Stepper';
import Step from '@design-system/components/Step';
import Form from '@design-system/components/Form';

const defaultConfig = {
  chart: {
    settings: {
      conditions: {
        owner: '',
        ownerId: '',
        start: null,
        end: null,
        category: '',
        granularity: '',
        resource: '',
        vendor: '',
      },
      preferences: {
        currency: 'usd',
        granularity: 'daily',
        category: 'service',

        // Chart type
        defaultChartType: 'stacked',

        // Range
        defaultRange: 'lastMonth',

        // Series
        defaultSeries: { service: [], account: [] },
        defaultSeriesCount: 5,
        nonGroupingSeriesCount: 5,

        // Total
        showTotal: true,
        totalColor: '#ff9800',
        totalStrokeType: 'solid-bullet',
        totalLineWidth: 2,

        // Others
        othersColor: '#009688',

        // Style
        scrollbar: true,
        animated: true,
        grouping: true,

        // Export
        exportDataType: 'csv',
        exportImageType: 'svg',
        exportPrefix: 'chart',

        // Datatable
        defaultTableRowsPerPage: 10,
      },
    },
    w: 9,
    h: 40,
  },
};

const messages = {
  en: {
    Cancel: 'Cancel',
    Save: 'Save',
    Next: 'Next',
    Back: 'Back',
    'Create New Dashboard': 'Create New Dashboard',
    'Dashboard Settings': 'Dashboard Settings',
    'Dashboard name': 'Dashboard name',
    'Please enter the dashboard name.': 'Please enter the dashboard name.',
    'Please enter within 30 characters.': 'Please enter within 30 characters.',
    'Add widget': 'Add widget',
    'RI/SP Widget': 'RI/SP Widget',
  },
  ja: {
    Cancel: 'キャンセル',
    Save: '保存する',
    Next: '次へ',
    Back: '戻る',
    'Create New Dashboard': 'ダッシュボード追加',
    'Dashboard Settings': 'ダッシュボード設定',
    'Dashboard name': 'ダッシュボード名',
    'Please enter the dashboard name.': 'ダッシュボード名を入力してください',
    'Please enter within 30 characters.': 'Please enter within 30 characters.',
    'Add widget': 'ウィジェット追加',
    'RI/SP Widget': 'RI/SP ウィジェット',
  },
};

export default {
  name: 'DialogCreateDashboard',
  i18n: { messages: messages },
  components: {
    ButtonToggle,
    Input,
    Panel,
    Stepper,
    Step,
    Form,
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      step: 1,
      dashboardName: '',
      layout: null,
      menuList: [
        {
          label: 'Settings',
          icon: 'o_settings',
          separator: true,
        },
        {
          label: 'Widgets',
          icon: 'dashboard',
          separator: true,
        },
      ],
      activeMenuItem: 'Settings',
      tableData: [
        {
          user: 'Hajime',
          role: 'owner',
        },
        {
          user: 'Syakir',
          role: 'editor',
        },
        {
          user: 'Ahmed',
          role: 'viewer',
        },
      ],
      columns: [
        {
          name: 'user',
          label: 'User',
          field: 'user',
          align: 'left',
          style: 'min-width: 120px;',
        },
        {
          name: 'role',
          label: this.$t('Role'),
          field: 'role',
          align: 'left',
          style: 'min-width: 350px;',
        },
        { name: 'actionMenu', label: '', required: true },
      ],
      userRoleOptions: [
        { label: this.$t('Owner'), value: 'owner' },
        { label: this.$t('Editor'), value: 'editor' },
        { label: this.$t('Viewer'), value: 'viewer' },
      ],
      buttonToggleValue: 'private',
      buttonToggleOptions: [
        { label: this.$t('Private'), value: 'private' },
        { label: this.$t('Public'), value: 'public' },
      ],
    };
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters('dashboard', {
      dashboards: 'dashboards',
    }),
    currentVisible: {
      set(val) {
        this.$emit('update:visible', val);
      },
      get() {
        return this.visible;
      },
    },
  },
  methods: {
    ...mapMutations('dashboard', {
      updateCurrentDashboardId: 'updateCurrentDashboardId',
    }),
    ...mapActions('dashboard', {
      saveDashboard: 'saveDashboard',
    }),
    resetDialog() {
      this.dashboardName = '';
      this.layout = null;
      this.step = 1;
      this.buttonToggleValue = 'private';
    },
    handleAddWidget(type) {
      this.layout = [
        {
          x: 0,
          y: 0,
          w: defaultConfig[type].w,
          h: defaultConfig[type].h,
          i: 0,
          static: true,
          widget: type,
          settings: defaultConfig[type].settings,
        },
      ];
    },
    isSelected(type) {
      return this.layout && this.layout[0].widget === type;
    },
    async handleNext() {
      const success = await this.$refs.myForm.validate();
      if (success) this.step = 2;
      return;
    },
    handleSubmit() {
      if (this.layout) {
        const dashboard = {
          name: this.dashboardName,
          isPublic: this.buttonToggleValue === 'public',
          widgets: this.layout,
        };

        this.saveDashboard(dashboard);

        this.dashboardName = '';
        this.layout = null;

        this.currentVisible = false;
      } else {
        //TODO: show error message to add at least one widget
      }
      return;
    },
  },
};
</script>

<style lang="scss">
.dialog-create-dashboard {
  z-index: 999 !important;
}
</style>

<style lang="scss" scoped>
.bg-content {
  background-color: $background;
}
.q-item__section--avatar ::v-deep {
  min-width: auto;
}
.hover-border {
  .q-card {
    border: 2px solid transparent;
  }
  &.active .q-card {
    border: 2px solid $primary;
  }
  .q-card:hover {
    border: 2px solid $primary;
  }
}
</style>
